const LoadingActionTypes = {
	START_LOADING: 'START_LOADING',
	STOP_LOADING: 'STOP_LOADING'
}

export default LoadingActionTypes;